class SessionStorage {
  constructor(prefix) {
    this.prefix = prefix ? prefix : undefined;
  }

  setSessionStorageItem = (key, data) => {
    sessionStorage.setItem(key, data);
  }

  getSessionStorageItem = (key) => {
    return sessionStorage.getItem(key);
  }

  removeSessionStorageItem = (key) => {
    sessionStorage.removeItem(key);
  }

  clearSessionStorage = () => {
    sessionStorage.clear();
  }
}

export default new SessionStorage();


// WEBPACK FOOTER //
// ./src/storage/SessionStorage/SessionStorage.js